import Text from '@cartwhl/ui/base/TextNew';
import FileIcon from '@cartwhl/ui/icons/FileIcon';

export interface DashboardFolderPreviewProps {
  label: string;
  imageSrc?: string;
}

export default function DashboardFolderPreview({
  label,
  imageSrc,
}: DashboardFolderPreviewProps) {
  return (
    <div className="bg-tertiary flex h-full w-full items-center justify-center">
      {imageSrc ? (
        <img src={imageSrc} alt="" className="h-[109px] w-[90px]" />
      ) : (
        <div className="relative h-24 w-24">
          <FileIcon className="text-tertiary absolute left-7 top-0 h-16 w-16" />
          <FileIcon className="text-secondary absolute left-4 top-2 h-16 w-16" />
          <div className="text-secondary absolute left-0 top-4 flex h-16 w-16 items-center justify-center">
            <FileIcon className="absolute inset-0 h-full w-full" />
            <Text
              token="12/medium"
              className="text-tertiary relative max-w-11 truncate"
            >
              {label}
            </Text>
          </div>
        </div>
      )}
    </div>
  );
}
